import { render } from "./ProductSelectionStep.vue?vue&type=template&id=27184428"
import script from "./ProductSelectionStep.vue?vue&type=script&lang=js"
export * from "./ProductSelectionStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__